import React from 'react';
import cl from './Input.module.css';

const Input = ({ isError = false, className = '', ...rest }) => {
  const inputClassName = [
    cl.genInput,
    isError ? cl.genInputError : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <input
      className={inputClassName}
      {...rest}
    />
  );
};

export default Input